import { BASE_SIZE, BASE_VARIANT } from '../constant';

const { PRIMARY, DANGER } = BASE_VARIANT;
const { XS, SM, MD } = BASE_SIZE;

export const TEXT_BUTTON_VARIANT = { PRIMARY, DANGER } as const;
export const TEXT_BUTTON_SIZE = { XS, SM, MD } as const;
